import React, { FC, useMemo } from 'react';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { isTaskChecked } from '../../utils/TaskItemUtils';

const getTaskAnswersFromWalkthrough = (walkthrough) => {
	const allTaskAnswers = nullSafeGetOrElse('taskAnswers', walkthrough, []);
	return allTaskAnswers.flatMap((ta) => nullSafeGetOrElse('taskListAnswer', ta, []));
};

const getStatusColors = (allTaskListAnswers) => {
	const checkedCount = allTaskListAnswers.filter(isTaskChecked).length;

	const totalCount = allTaskListAnswers.length;

	const diffPercentage = (checkedCount || 0) / (totalCount || 1);
	if (diffPercentage < 0.5) {
		return {
			color: '#FF4D4F',
			bgColor: '#f9e6e6',
		};
	} else if (diffPercentage < 1) {
		return {
			color: '#E59D0D',
			bgColor: 'rgb(252, 243, 217)',
		};
	} else {
		return {
			color: '#4B5563',
			bgColor: 'rgb(230, 249, 231)',
		};
	}
};

export const TaskListScoreDisplay: FC<any> = ({ allTaskListAnswers }): React.ReactElement => {
	const checkedCount = useMemo(
		() => allTaskListAnswers.filter(isTaskChecked).length,
		[allTaskListAnswers]
	);

	const totalCount = useMemo(() => allTaskListAnswers.length, [allTaskListAnswers.length]);

	return (
		<div
			className="h5regular"
			style={{ color: getStatusColors(allTaskListAnswers).color }}
		>{`${checkedCount}/${totalCount}`}</div>
	);
};

export const GroupedTaskTaskListScoreDisplay: FC<any> = ({
	groupedAnswers,
}): React.ReactElement => {
	const allTaskListAnswers = useMemo(
		() => groupedAnswers.flatMap((ta) => nullSafeGetOrElse('taskListAnswer', ta, [])),
		[groupedAnswers]
	);

	return allTaskListAnswers.length > 0 ? (
		<div className="flex flex-row items-center gap-2">
			<div className="h5regular text-[#4B5563]">Task List:</div>
			<TaskListScoreDisplay allTaskListAnswers={allTaskListAnswers} />
		</div>
	) : null;
};

export const WalkthroughTaskListScorePill: FC<any> = ({ walkthrough }): React.ReactElement => {
	const allTaskListAnswers = useMemo(
		() => getTaskAnswersFromWalkthrough(walkthrough),
		[walkthrough]
	);

	return allTaskListAnswers.length > 0 ? (
		<div
			className="flex flex-row items-center gap-2"
			style={{
				background: getStatusColors(allTaskListAnswers).bgColor,
				padding: '4px 12px',
				borderRadius: 16,
				textTransform: 'capitalize',
			}}
		>
			<div className="h5regular text-[#4B5563]">Task List:</div>
			<TaskListScoreDisplay allTaskListAnswers={allTaskListAnswers} />
		</div>
	) : null;
};

const WalkthroughTaskListScoreDisplay: FC<any> = ({ walkthrough }): React.ReactElement => {
	const allTaskListAnswers = useMemo(
		() => getTaskAnswersFromWalkthrough(walkthrough),
		[walkthrough]
	);

	return allTaskListAnswers.length > 0 ? (
		<TaskListScoreDisplay allTaskListAnswers={allTaskListAnswers} />
	) : null;
};

export default WalkthroughTaskListScoreDisplay;
